import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React from 'react'
import { ZoomableThumbnail } from '../../../components'

type VisualizationProps = {
  base64: string
  type?: string
}
export function Visualization({ base64, type = 'image/png' }: VisualizationProps): JSX.Element {
  const { _t } = useTypedTranslation()

  const items = [{ base64, mediaType: type }]

  return (
    <ZoomableThumbnail
      items={items}
      title="File Visualization"
      otherContent={{
        afterImage: (
          <div className="mt-3">
            <span className="text-capital">{_t('source')}</span>:
            <a
              href="https://github.com/katjahahn/PortEx"
              target="_blank"
              rel="noreferrer"
              className="text-default ms-2"
            >
              https://github.com/katjahahn/PortEx
            </a>
          </div>
        ),
      }}
    />
  )
}
